// extracted by mini-css-extract-plugin
export default {"predefinedQuestionsContainer":"HelpAndSupportModal_predefinedQuestionsContainer__6yAW4","predefinedQuestionButton":"HelpAndSupportModal_predefinedQuestionButton__52eZr"};